// 引导页
import { Dimensions } from "~/ui/primitives"
import Swiper from "~/ui/swiper"
import FastImage from "~/ui/FastImage"
import useNavigation from "~hooks/useNavigation"
import { ButtonSolid, ButtonOutline } from "~components/button"
import { useStores } from "~models"
import styled from '~/ui/styled'
import { CenterFlex, ColumnFlex, Flex } from "~components/El"

const SliderBg = styled(ColumnFlex)`
  position: relative;
  flex: 1;
  height: 100%;
  min-height: 0;
  align-items: center;
  background-color: white;
`

const IntroPage = styled.div`
  flex: 1;
  min-height: 0;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  padding: 24px;
  box-sizing: border-box;
`

const IntroCard = styled.div`
  width: 100%;
  max-width: 520px;
  height: 100%;
  max-height: calc(100vh - 48px);
  border-radius: 16px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.18);
  display: flex;
  flex-direction: column;
`

const Logo = styled(FastImage)`
  width: ${() => `${370 / 6}px`};
  height: ${() => `${370 / 6}px`};
  margin-top: ${() => `${370 / 32}px`};
`

const MainTitle = styled.Text`
  color: ${({ theme }) => theme.colors.text};
  font-size: 20px;
  font-weight: 500;
  margin-top: 12px;
`

const MainImage = styled(FastImage)`
  width: ${() => `100%`};
  height: auto;
  /* margin-top: 20px; */
`

const Title = styled.Text`
  color: ${({ theme }) => theme.colors.primary};
  font-size: ${() => `${370 / 18}px`};
  font-weight: bold;
  margin-top: 20px;
  margin-bottom: 12px;
`

const Text = styled.Text`
  color: ${({ theme }) => theme.colors.secondaryText};
  text-align: center;
  font-size: 16px;
  line-height: 28px;
  font-weight: bold;
`

const Dot = styled.View`
  background-color: rgba(0, 0, 0, 0.2);
  width: 8px;
  height: 8px;
  border-radius: 4px;
  margin-left: 3px;
  margin-right: 3px;
  margin-top: 3px;
  margin-bottom: 3px;
`

const ActiveDot = styled.View`
  background-color: ${({ theme }) => theme.colors.primary};
  width: 20px;
  height: 8px;
  border-radius: 4px;
  margin-left: 3px;
  margin-right: 3px;
  margin-top: 3px;
  margin-bottom: 3px;
`

const ButtonAreaWrapper = styled(Flex)`
  z-index: 2;
  width: 100%;
  height: auto;
  flex-direction: row;
  justify-content: center;
  margin-top: 20px;
`

const ButtonWrapper = styled(CenterFlex)`
  /* width: 30%; */
  margin: 0px 20px;
`

const BottomWave = styled(FastImage)`
  position: absolute;
  bottom: 0px;
  width: ${() => '100%'};
  height: ${() => `${Dimensions.get("window").height / 7}px`};
`

const DotComponent = () => <Dot></Dot>
const ActiveDotComponent = () => <ActiveDot></ActiveDot>

const AppIntro = () => {
  const { authStore, configStore } = useStores()

  const sliders = [
    {
      key: "slider1",
      logo: {
        src: require("../../../assets/images/app-intro-logo.png"),
        resizeMode: FastImage.resizeMode.stretch,
      },
      mainTitle: `${configStore.appName} IM`,
      mainImage: {
        src: require("../../../assets/images/app-intro-image-1.png"),
        resizeMode: FastImage.resizeMode.stretch,
      },
      title: "截屏提醒 匿名群聊",
      texts: ["防止信息被恶意保存/泄露/传播", "群聊匿名说出想说的话"],
      bottomWave: {
        src: require("../../../assets/images/app-intro-bottom-wave.png"),
        resizeMode: FastImage.resizeMode.stretch,
      },
    },
    // {
    //   key: "slider2",
    //   logo: {
    //     src: require("../../../assets/images/app-intro-logo.png"),
    //     resizeMode: FastImage.resizeMode.stretch,
    //   },
    //   mainTitle: `${configStore.appName} IM`,
    //   mainImage: {
    //     src: require("../../../assets/images/app-intro-image-3.png"),
    //     resizeMode: FastImage.resizeMode.stretch,
    //   },
    //   title: "加密聊天 端到端加密",
    //   texts: ["端到端加密保证 没有人可以拦截您的消息", "互联网供应商也无法窃听您的对话"],
    //   bottomWave: {
    //     src: require("../../../assets/images/app-intro-bottom-wave.png"),
    //     resizeMode: FastImage.resizeMode.stretch,
    //   },
    // },
  ]
  const computedSliders = sliders.map((slider, i) => ({
    ...slider,
    isLastSlider: i === sliders.length - 1,
  }))
  const initPageIndex = 0
  const navigation = useNavigation()
  const onLoginButtonClick = () => {
    authStore.setHaveBeenPassIntro(true)
    navigation.push("Login")
  }
  const onRegisterButtonClick = () => {
    authStore.setHaveBeenPassIntro(true)
    navigation.push("Register")
  }
  return (
    <IntroPage>
      <IntroCard>
        <Swiper
          horizontal={true}
          loop={false}
          index={initPageIndex}
          showsButtons={false}
          autoplay={false}
          showsPagination={true}
          paginationStyle={{ marginBottom: Dimensions.get("window").height / 30 }}
          dot={DotComponent()}
          activeDot={ActiveDotComponent()}
        >
          {computedSliders.map(
            ({ key, logo, mainTitle, mainImage, title, texts, bottomWave, isLastSlider }) => {
              return (
                <SliderBg key={key}>
                  <Logo src={logo.src} resizeMode={logo.resizeMode} />
                  <MainTitle>{mainTitle}</MainTitle>
                  <MainImage src={mainImage.src} resizeMode={mainImage.resizeMode} />
                  <Title>{title}</Title>
                  {texts.map((text) => (
                    <Text key={text}>{text}</Text>
                  ))}
                  {isLastSlider && (
                    <ButtonAreaWrapper>
                      <ButtonWrapper>
                        <ButtonSolid text="登录" onClick={onLoginButtonClick}></ButtonSolid>
                      </ButtonWrapper>
                      <ButtonWrapper>
                        <ButtonOutline text="注册" onClick={onRegisterButtonClick}></ButtonOutline>
                      </ButtonWrapper>
                    </ButtonAreaWrapper>
                  )}
                  <BottomWave src={bottomWave.src} resizeMode={bottomWave.resizeMode} />
                </SliderBg>
              )
            },
          )}
        </Swiper>
      </IntroCard>
    </IntroPage>
  )
}

export default AppIntro
